/**
 * Limit in meters after which a message is displayed to the user to let him know that the nearest store is far away.
 */
export const DISTANCE_LIMIT_BEFORE_WARNING = 50_000;

/**
 * In the case of a search (except country), maximum number of stores displayed if there is no shop in the area
 */
export const MAX_SHOP_TO_DISPLAY = 5;
